import type { QuoteFile } from 'paintscout'

/**
 * Splits a multi-file pick or drop for a field that holds exactly one file (#23709). The first file
 * fills that field, and the rest belong to the block that owns it — a Gallery tile, today. Returns
 * every file it actually handed out, in order, so the caller can act on the whole set at once (the
 * Gallery adds them all to the presentation library).
 *
 * Callers pass `applyFirst` rather than a plain file back, because applying to a slot can transform
 * the file (InlineEditableMedia merges the slot's own `presentationOptions` into it).
 */
export function applyMultiFileSelection(args: {
  files: QuoteFile[]
  applyFirst: (file: QuoteFile) => QuoteFile | void
  onRest?: (files: QuoteFile[]) => void
}): QuoteFile[] {
  const { files, applyFirst, onRest } = args
  const [first, ...rest] = files ?? []

  if (!first) return []

  const applied = applyFirst(first) || first

  if (rest.length && onRest) onRest(rest)

  return [applied, ...rest]
}
